import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { BrandHeader, BrandFooter, useBrand, getBrand } from "@/components/customer/Brand";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useT } from "@/lib/i18n";

export default function FindBooking() {
  const nav = useNavigate();
  const t = useT();
  const brand = useBrand(getBrand());
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const submit = (e) => {
    e.preventDefault();
    nav(`/booking/${code.trim().toUpperCase()}?email=${encodeURIComponent(email.trim())}`);
  };
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <BrandHeader brand={brand} />
      <main className="mx-auto max-w-md px-4 py-16">
        <form onSubmit={submit} className="fade-up rounded-2xl border border-slate-200 bg-white p-8 shadow-sm" data-testid="find-booking-form">
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900">{t("Cek pesanan")}</h1>
          <p className="mt-2 text-sm text-slate-500">{t("Masukkan kode booking dan email yang dipakai saat memesan.")}</p>
          <div className="mt-6 space-y-4">
            <div><Label htmlFor="fcode">{t("Kode booking")}</Label>
              <Input id="fcode" data-testid="find-code-input" required value={code} onChange={(e) => setCode(e.target.value)} placeholder="BKXXXXXX" className="mt-1.5 font-mono-x uppercase" /></div>
            <div><Label htmlFor="femail">Email</Label>
              <Input id="femail" data-testid="find-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" /></div>
          </div>
          <button type="submit" data-testid="find-submit-button"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-[#5392F9] py-3 font-heading font-bold text-white transition-colors hover:bg-[#3B7BE6]">
            <Search className="h-4 w-4" /> {t("Cari booking")}
          </button>
        </form>
      </main>
      <BrandFooter brand={brand} />
    </div>
  );
}
